namespace Matrix.Administration {

    @Serenity.Decorators.registerClass()
    export class RoleGrid extends SiteEntityGrid<RoleRow, any> {
        protected getColumnsKey() { return "Administration.Role"; }
        protected getDialogType() { return RoleDialog; }
        protected getIdProperty() { return RoleRow.idProperty; }
        protected getLocalTextPrefix() { return RoleRow.localTextPrefix; }
        protected getService() { return RoleService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getDefaultSortBy() {
            return [RoleRow.Fields.RoleName];
        }

        protected getColumns() {
            var columns = super.getColumns();

            var permissionSets = Q.tryFirst(columns, x => x.field == RoleRow.Fields.PermissionSets);
            if (permissionSets) {
                permissionSets.format = ctx => {
                    var permissionSetNames = (ctx.value || [])
                        .map(x => (PermissionSetRow.getLookup().itemById[x] || {}).Name || "");
                    permissionSetNames.sort();
                    return permissionSetNames.join(", ");
                };
            }

            var groups = Q.tryFirst(columns, x => x.field == RoleRow.Fields.Groups);
            if (groups) {
                groups.format = ctx => {
                    var groupNames = (ctx.value || []).map(x => (GroupRow.getLookup().itemById[x] || {}).Name || "");
                    groupNames.sort();
                    return groupNames.join(", ");
                };
            }

            return columns;
        }
    }
}